import { useMemo } from 'react';
import useFilterStore from '../streetview/filterStore';
import { FrontendFilterValue } from '../../types/filters.type';
import FilterDescription from '../streetview/filterDescription';

export default function MultiCheckbox({
  title,
  label,
  labelId,
  filterValues,
  description,
  featureFlag,
}: Readonly<{
  title: string,
  label: string,
  labelId: string,
  filterValues: FrontendFilterValue[],
  description?: string | null,
  featureFlag?: string | null,
}>) {
  const selectedFilters = useFilterStore((state) => state.selectedFilters);
  const toggleSelectedFilter = useFilterStore((state) => state.toggleSelectedFilter);

  const clonedValues = useMemo(() => structuredClone(filterValues).map((filter) => {
    const isSelected = Boolean(selectedFilters[title]?.[labelId]?.selectedValues?.some(
      (selectedValue) => selectedValue.id === filter.id,
    ));

    return { ...filter, isSelected };
  }), [filterValues, selectedFilters, title, labelId]);

  const handleCheckboxChange = (option: FrontendFilterValue) => {
    toggleSelectedFilter(title, labelId, label, option);
  };

  return (
    <fieldset
      id={`fieldset-${labelId}`}
      aria-describedby={`${labelId}-description`}
    >
      <legend className="input-label">{label}</legend>
      <FilterDescription ariaId={`${labelId}-description`} description={description} featureFlag={featureFlag} />
      <div className="flex flex-col ">
        <ul>
          {clonedValues.map((option) => (
            <li className="my-1" key={option.id}>
              <label htmlFor={`${labelId}-${option.id}`} className="flex items-center text-piptext-body">
                <input
                  type="checkbox"
                  id={`${labelId}-${option.id}`}
                  name={option.id}
                  checked={option.isSelected}
                  onChange={() => handleCheckboxChange({ id: option.id, displayName: option.displayName })}
                  value={option.id}
                  className="mr-2 accent-primary"
                />
                {option.displayName}
              </label>
            </li>
          ))}
        </ul>
      </div>
    </fieldset>
  );
}
